import { AliasToken } from 'antd/es/theme/interface';

export interface IToken {
  token: AliasToken;
}

export interface IFilters {
  filter: string;
  options: ISelectionOption[];
}

export interface ISelectionOption {
  value: string;
  label: string;
  id: number;
  name_of_entity: string;
}

export interface IFiltersLei {
  filter: string;
  options: ISelectionOptionLei[];
}

export interface ISelectionOptionLei {
  value: string;
  financial_entity_lei_id: number;
  id: number;
  name_of_entity: string;
  label: string;
}

export interface IResponseFilters {
  ent?: number;
}

export enum ThemeList {
  MAIN_THEME = 'mainTheme',
  CORAL_MIST = 'contrastBloom',
  FIRST_THEME = 'firstTheme',
  SECOND_THEME = 'secondTheme',
  FIFTH_THEME = 'fifthTheme',
  SEVENTH_THEME = 'seventhTheme',
  EIGHTH_THEME = 'eighthTheme',
  NINTH_THEME = 'ninethTheeme',
  LILAC_THEME = 'lilacTheme',
  SLATE_STEEL = 'slateSteel',
  TURQUOISE = 'turquoiseTheme',
  LIGHT_UI_THEME = 'arcticHorizonTheme',
}

export interface ICustomMenuItem {
  label: JSX.Element;
  key: string;
  path: string;
}

export enum TitleList {
  WORKING_AREAS = 'TITLE.WORKING_AREAS',
  INFO_REG = 'TITLE.INFO_REG',
  DATA_ENTRY = 'TITLE.DATA_ENTRY',
  MASTER_DATA = 'TITLE.MASTER_DATA',
  REPORTING = 'TITLE.REPORTING',
  ADDITIONAL_REPORTING = 'TITLE.ADDITIONAL_REPORTING',
  SUPER_ADMIN = 'TITLE.SUPER_ADMIN',
  ARTICLE8 = 'TITLE.ARTICLE8',
  ARTICLE_8_REPORT = 'TITLE.ARTICLE_8_REPORT',
  DASHBOARD = 'TITLE.DASHBOARD',
  ALLOCATION = 'TITLE.ALLOCATION',
  ICTRISKSTOTPP = 'TITLE.ICTRISKSTOTPP',
  ENTITYTOFUNCTION = 'TITLE.ENTITYTOFUNCTION',
  ENTITYTOTPP = 'TITLE.ENTITYTOTPP',
  ENTITYTOFUNCTIONREVERSE = 'TITLE.ENTITYTOFUNCTIONREVERSE',
}

export enum TitleDataEntry {
  ENTITY = 'DATA_ENTRY.ENTITY',
  ENTITY_MAINTAINING_REGISTRY = 'DATA_ENTRY.ENTITY_MAINTAINING_REGISTRY',
  THIRD_PARTY_PROVIDER = 'DATA_ENTRY.THIRD_PARTY_PROVIDER',
  FUNCTION = 'DATA_ENTRY.FUNCTION',
  ICT_SERVICES = 'DATA_ENTRY.ICT_SERVICES',
  CONTRACTUAL_INFORMATION = 'DATA_ENTRY.CONTRACTUAL_INFORMATION',
  BRANCH = 'DATA_ENTRY.BRANCH',
  DATA = 'DATA_ENTRY.DATA',
  REPORT99 = 'DATA_ENTRY.REPORT99',
  ICT_SYSTEMS = 'DATA_ENTRY.ICT_SYSTEMS',
}

export enum TitleArticle8 {
  ICTRiskLevel = 'ARTICLE8_TITLES.ICT_RISK_LEVEL',
  ICTRiskExposure = 'ARTICLE8_TITLES.ICT_RISK_EXPOSURE',
  DependencyType = 'ARTICLE8_TITLES.DEPENDENCY_TYPE',
  ExposureCategory = 'ARTICLE8_TITLES.EXPOSURE_CATEGORY',
  ICTSystemCriticality = 'ARTICLE8_TITLES.ICT_SYSTEM_CRITICALITY',
  Entityrole = 'ARTICLE8_TITLES.ENTITY_ROLE',
  RoleType = 'ARTICLE8_TITLES.ROLE_TYPE',
  ICTRisk = 'ARTICLE8_TITLES.ICT_RISK',
  ICTRiskSource = 'ARTICLE8_TITLES.ICT_RISK_SOURCE',
  Responsibilities = 'ARTICLE8_TITLES.RESPONSIBILITIES',
}

export interface IChangePass {
  old_password: string;
  new_password: string;
}

export interface IResetPass {
  password: string;
}
